import React, { Fragment } from 'react';
import { Row, Col, SvgIcon } from 'seduo-ui';
export default class Example extends React.Component {
    render() {
        return (<Fragment>
                <Row>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-brand-dark"/> .icon-brand-dark
                    </Col>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-brand-light"/> .icon-brand-light
                    </Col>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-brand-orange"/> .icon-brand-orange
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-primary"/> .icon-primary
                    </Col>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-alternative"/> .icon-alternative
                    </Col>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-success"/> .icon-success
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-info"/> .icon-info
                    </Col>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-warning"/> .icon-warning
                    </Col>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-danger"/> .icon-danger
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-muted"/> .icon-muted
                    </Col>
                    <Col sm={4}>
                        <SvgIcon kind="Smile" className="icon icon-dark"/> .icon-dark
                    </Col>
                </Row>
                <Row>
                    <Col sm={4} className="bg-brand-dark text-white">
                        <SvgIcon kind="Smile" className="icon icon-light"/> .icon-light
                    </Col>
                    <Col className="bg-brand-dark text-white">
                        <SvgIcon kind="Smile" className="icon icon-white"/> .icon-white
                    </Col>
                </Row>
            </Fragment>);
    }
}
